const saveInLocalStorage = (key, name, value) => {
  const filters = localStorage.getItem(key)
  const withNewItem = { ...JSON.parse(filters) }
  withNewItem[name] = value
  localStorage.setItem(key, JSON.stringify(withNewItem))
}

export { saveInLocalStorage }
